module.exports = __webpack_public_path__ + "img/about-real2.26702379.webp";